export class NeoNivelVentaIntermediarioDTO {
    constructor(
      public idNivelVentasIntermediario: Number,
      public idCliente: Number,
      public nivelVentasInicial: Number,
      public nivelVentasFinal: Number,
      public fechaCreacion: Number,
      public idUsuario: Number,
      public justificacion: String,
      public nombreCliente: String
    ) {}
  }